import React, { useState } from 'react';

const zipCodeAreas = {
  "77001": "Downtown",
  "77002": "Downtown",
  "77003": "East Downtown",
  "77004": "Midtown",
  "77005": "West University Place",
  "77006": "Montrose",
  "77007": "Rice Military",
  "77008": "The Heights",
  "77009": "Northside Village",
  "77010": "Downtown",
  "77011": "East End",
  "77012": "East End",
  "77013": "Northeast Houston",
  "77014": "Northcliffe",
  "77015": "North Shore",
  "77016": "Trinity Gardens",
  "77017": "Park Place",
  "77018": "The Heights",
  "77019": "River Oaks",
  "77020": "Fifth Ward",
  "77021": "MacGregor",
  "77022": "Northline",
  "77023": "Eastwood",
  "77024": "Memorial",
  "77025": "Braeswood Place",
  "77026": "Greater Fifth Ward",
  "77027": "Afton Oaks",
  "77028": "Northeast Houston",
  "77029": "Northeast Houston",
  "77030": "Texas Medical Center",
  "77031": "Westwood",
  "77032": "Aldine",
  "77033": "South Acres",
  "77034": "Edgebrook",
  "77035": "Westbury",
  "77036": "Sharpstown",
  "77037": "Aldine",
  "77038": "Inwood",
  "77039": "East Aldine",
  "77040": "Jersey Village",
  "77041": "Spring Branch",
  "77042": "Westchase",
  "77043": "Spring Branch",
  "77044": "Summerwood",
  "77045": "Central Southwest",
  "77046": "Greenway",
  "77047": "Central Southwest",
  "77048": "South Acres",
  "77049": "North Shore",
  "77050": "Northeast Houston",
  "77051": "South Park",
  "77052": "Houston",
  "77053": "Fort Bend",
  "77054": "Astrodome",
  "77055": "Spring Branch",
  "77056": "Galleria",
  "77057": "Galleria",
  "77058": "Clear Lake",
  "77059": "Clear Lake",
  "77060": "Aldine",
  "77061": "Greater Hobby Area",
  "77062": "Clear Lake",
  "77063": "Woodlake",
  "77064": "Jersey Village",
  "77065": "Copperfield",
  "77066": "Willowbrook",
  "77067": "Aldine",
  "77068": "Champion Forest",
  "77069": "Memorial",
  "77070": "Meyerland",
  "77071": "Alief",
  "77072": "Greenspoint",
  "77073": "Sharpstown",
  "77074": "South Belt",
  "77075": "Northside",
  "77076": "West Oaks",
  "77077": "Settegast",
  "77078": "Memorial",
  "77079": "Spring Branch",
  "77080": "Bellaire",
  "77081": "West Oaks",
  "77082": "Mission Bend",
  "77083": "Addicks",
  "77084": "Central Southwest",
  "77085": "Acres Homes",
  "77086": "Greater Hobby Area",
  "77087": "Inwood",
  "77088": "South Belt",
  "77089": "Greenspoint",
  "77090": "Oak Forest",
  "77091": "Eastex",
  "77092": "Energy Corridor",
  "77093": "Copperfield",
  "77094": "Meyerland",
  "77095": "Houston",
  "77096": "Neartown",
  "77097": "Houston",
  "77098": "Houston",
  "77099": "Houston",
  "77201": "Houston",
  "77202": "Houston",
  "77203": "Houston",
  "77204": "Houston",
  "77205": "Houston",
  "77206": "Houston",
  "77207": "Houston",
  "77208": "Houston",
  "77209": "Houston",
  "77210": "Houston",
  "77212": "Houston",
  "77213": "Houston",
  "77215": "Houston",
  "77216": "Houston",
  "77217": "Houston",
  "77218": "Houston",
  "77219": "Houston",
  "77220": "Houston",
  "77221": "Houston",
  "77222": "Houston",
  "77223": "Houston",
  "77224": "Houston",
  "77225": "Houston",
  "77226": "Houston",
  "77227": "Houston",
  "77228": "Houston",
  "77229": "Houston",
  "77230": "Houston",
  "77231": "Houston",
  "77233": "Houston",
  "77234": "Houston",
  "77235": "Houston",
  "77236": "Houston",
  "77237": "Houston",
  "77238": "Houston",
  "77240": "Houston",
  "77241": "Houston",
  "77242": "Houston",
  "77243": "Houston",
  "77244": "Houston",
  "77245": "Houston",
  "77248": "Houston",
  "77249": "Houston",
  "77251": "Houston",
  "77252": "Houston",
  "77253": "Houston",
  "77254": "Houston",
  "77255": "Houston",
  "77256": "Houston",
  "77257": "Houston",
  "77258": "Houston",
  "77259": "Houston",
  "77261": "Houston",
  "77262": "Houston",
  "77263": "Houston",
  "77265": "Houston",
  "77266": "Houston",
  "77267": "Houston",
  "77268": "Houston",
  "77269": "Houston",
  "77270": "Houston",
  "77271": "Houston",
  "77272": "Houston",
  "77273": "Houston",
  "77274": "Houston",
  "77275": "Houston",
  "77277": "Houston",
  "77279": "Houston",
  "77280": "Houston",
  "77282": "Houston",
  "77284": "Houston",
  "77285": "Houston",
  "77286": "Houston",
  "77287": "Houston",
  "77288": "Houston",
  "77289": "Houston",
  "77290": "Houston",
  "77291": "Houston",
  "77292": "Houston",
  "77293": "Houston",
  "77297": "Houston",
  "77298": "Houston",
  "77299": "Houston"
};

const PopUpModal = ({ showModal, setShowModal }) => {
  const [zipCode, setZipCode] = useState('');
  const [message, setMessage] = useState('');
  const [fade, setFade] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (zipCodeAreas.hasOwnProperty(zipCode)) {
      setMessage(`Hello from ${zipCodeAreas[zipCode]}, welcome to Africfresh!`);
    } else {
      setMessage('Welcome new user!');
    }
    setFade(true);
    setTimeout(() => {
      if (zipCodeAreas.hasOwnProperty(zipCode)) {
        localStorage.setItem('zipCode', zipCode);
        localStorage.setItem('timestamp', Date.now().toString());
      }
      setShowModal(false);
    }, 3000); // Close the modal after 3 seconds
  };

  return (
    showModal && (
      <div className={`fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 ${fade ? 'fade-out' : 'fade-in'}`}>
        <div className="bg-white p-6 rounded-md shadow-md max-w-md w-full text-center">
          {!fade ? (
            <>
              <h2 className="text-xl text-[#154F16] font-semibold mb-4">Input your zip code</h2>
              <form onSubmit={handleSubmit}>
                <input
                  type="text"
                  value={zipCode}
                  onChange={(e) => setZipCode(e.target.value)}
                  placeholder="Enter zip code"
                  required
                  className="w-full px-4 py-2 mb-4 border rounded-md"
                />
                <button
                  type="submit"
                  className="px-4 py-2 bg-[#154F16] text-white rounded-md hover:bg-[#154F16]"
                >
                  Submit
                </button>
              </form>
            </>
          ) : (
            <p className="mt-4">{message}</p>
          )}
        </div>
      </div>
    )
  );
};

export default PopUpModal;
